import * as exBootstrap from '../../bootstrap';
import * as exToast from '../../components/toast';
import { merge } from '../../helper';
import { create } from './create';

// ----------------------------------------------------------------------------

function start(config: Record<string, any> = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {
        toastContainer: {
            placement: config.placement || 'bottomcenter',
        },
        show: true,
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // Create element (notify)
    const notify = create({
        merge: defConfig,
        toastContainer: {
            class: {
                add: 'position-fixed',
            },
            style: {
                padding: '14px',
            },
        },
        container: {
            parent: document.body,
        },
    });

    // If using show
    if (defConfig.show !== false) {
        show(notify.element);
    }

    // ------------------------------------------------------------------------

    // Return
    return notify;
}

// ----------------------------------------------------------------------------

function show(element: HTMLElement, config: Record<string, any> = {}): void {
    exBootstrap.show('Toast', element, config);
}

function update(element: HTMLElement, config: Record<string, any> = {}): void {
    // Get bootstrap type
    const bsType = exBootstrap.getCreateInstance('Toast', element);
    // If there is no bootstrap type
    if (bsType) {
        // Toast Show
        exToast.show(element, config);
    }
    // If there is bootstrap type
    else {
        // Create element (notify)
        start(config);
    }
}

function hide(element: HTMLElement, config: Record<string, any> = {}): void {
    // Get bootstrap type
    const bsType = exBootstrap.getCreateInstance('Toast', element);
    // If there is no bootstrap type
    if (!bsType) {
        return;
    }

    // Toast Dispose
    exToast.dispose(element, config);

    // Remove
    element.remove();
}

// ----------------------------------------------------------------------------

export { create, start, show, update, hide };
